const decorator = str => 'bepaid-page/' + str;

export const SUCCESS_ORDER_REQUESTING = decorator('SUCCESS_ORDER_REQUESTING');
export const SUCCESS_ORDER_LOADED = decorator('SUCCESS_ORDER_LOADED');
export const SUCCESS_ORDER_LOADED_WITH_ERROR = decorator('SUCCESS_ORDER_LOADED_WITH_ERROR');

export const FAIL_ORDER_REQUESTING = decorator('FAIL_ORDER_REQUESTING');
export const FAIL_ORDER_LOADED = decorator('FAIL_ORDER_LOADED');
export const FAIL_ORDER_LOADED_WITH_ERROR = decorator('FAIL_ORDER_LOADED_WITH_ERROR');
